module.exports = __webpack_public_path__ + "img/1.e739f665.png";